module.exports = __webpack_public_path__ + "img/lang-24.5636392a.jpg";